import router from '@/router/index';
import { apiService } from '@/services/APIService';
import Centrifuge from 'centrifuge';
import SockJS from 'sockjs-client';
import Vue from 'vue';

export const NOTIFICATION_TYPES = {
  CLIENT_QUESTION: 1,
  CHAT_MESSAGE: 2,
  TRANSFER: 3,
  INTERNAL_CHAT_MESSAGE: 4,
  ADMIN_MESSAGE: 5,
  TASK: 6,
};

export default {
  name: 'notification',
  namespaced: true,
  state: {
    centrifugo: null,
    notification: null,
  },

  getters: {
    notification: (state) => state.notification,
  },

  actions: {
    async init({ commit, rootGetters }) {
      try {
        const response = await apiService.post('centrifuge');
        if (!response) return;

        const { data } = response.data;

        const centrifugo = new Centrifuge(data.url, {
          sockjs: SockJS,
          onPrivateSubscribe: () => { },
          onRefresh: this.refreshCentrifuge,
        });

        centrifugo.setToken(data.token);
        centrifugo.connect();
        centrifugo.subscribe(`notification#${rootGetters['auth/getUser'].id}`, (notification) => {
          // eslint-disable-next-line global-require
          const audio = new Audio(require('@/assets/notification.ogg'));
          audio.play();

          Vue.$toast('У вас новое уведомление !', {
            timeout: 5000,
            onClick: () => {
              // TODO make save push
              router.push('/');
            },
          });
          commit('SET_NOTIFICATION', notification.data);
        });
        commit('SET_CENTRIFUGE', centrifugo);
      } catch (error) {
        Vue.$toast.error(error);
      }
    },
  },

  mutations: {
    SET_NOTIFICATION(state, data) {
      state.notification = data;
    },
    SET_CENTRIFUGE(state, data) {
      state.centrifugo = data;
    },
    DELETE_CENTRIFUGE(state) {
      if (state.centrifugo) state.centrifugo.disconnect();
      state.centrifugo = null;
    },
  },
};
